import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNginxComponent } from './simple-icons-nginx.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNginxComponent ],
    exports:      [ SimpleIconsNginxComponent ],
    bootstrap:    []
})
export class SimpleIconsNginxModule {}
